import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Newsletter } from '@utils/backend-api/newsletters';
import { LiveStream, TITVEvent } from '@utils/backend-api/titv';

import Description from './Description';
import EventStreamPlayer from './EventStreamPlayer';
import NewslettersSignup from './NewslettersSignUp';
import PastEvents from './PastEvents';
import { TITVPartnerAd } from './interfaces';

interface TITVProps {
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
  inProgressStream?: LiveStream;
  mostRecentStream?: TITVEvent;
  partnerAds?: TITVPartnerAd[];
  availableNewsletters?: Newsletter[];
}

const queryClient = new QueryClient();

const TITV = ({
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  env,
  inProgressStream,
  mostRecentStream,
  availableNewsletters,
  partnerAds,
}: TITVProps) => {
  const { Track } = useEventTracking({
    page: Page.TITV,
  });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        isWebview={isWebview}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <EventStreamPlayer
            inProgressStream={inProgressStream}
            mostRecentStream={mostRecentStream}
          />
          <div className="mt-72 px-28">
            <div className="m-auto max-w-container-lg">
              <Description partnerAds={partnerAds} />
              <PastEvents />
            </div>
          </div>
          {!initialCurrentUser && <NewslettersSignup newsletters={availableNewsletters} />}
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default TITV;
